export const DEFAULT_CUSTOMER_CONFIG = {
  Senbos: {
    Url: 'https://bccpic-staging01.snbos.com',
    ApiUsernamePasswordSecret:
      'arn:aws:secretsmanager:ap-southeast-2:123456789012:secret:PLACEHOLDER_SECRET_NAME',
  },
  StagingSenbos: {
    Url: 'https://bccpic-staging01.snbos.com',
    ApiUsernamePasswordSecret:
      'arn:aws:secretsmanager:ap-southeast-2:123456789012:secret:PLACEHOLDER_SECRET_NAME',
  },

  Grafana: {
    DashboardUid: '00000000-0000-0000-0000-000000000000',
    DashboardSlug: 'BCC-SENPIC',
    OrganizationId: 1,
  },
  Ftp: {
    Server: 'ftp-bcc.senforce.ai',
    Port: 2121,
  },
};

export const DEFAULT_SITE_CONFIG = {
  Timezone: 'Australia/Sydney',
  TunnelUrl: '',
  OcrRegions: ['NSW'],
};

export const DEFAULT_DEVICE_CONFIG = {
  Image: {
    Operations: [
      {
        $type: 'ImageRotationOperation',
        Degrees: 180,
      },
      {
        $type: 'ImageDataBlockOperation',
        Padding: 10,
        ZoneKey: '',
        SiteName: '',
        TextSize: 32,
        Timezone: '',
        Timestamp: '0001-01-01T00:00:00.000Z',
        DeviceName: '',
        CustomerName: '',
        TimestampUtc: '0001-01-01T00:00:00.000Z',
        DataBlockFormat:
          '{CustomerName}  Date: {Timestamp:dd MMMM yyyy}  Time: {Timestamp:HH\\:mm\\:ss}  Location: {SiteName}',
      },
    ],
    JpegQuality: 90,
  },
  state: {
    created: true,
    productionReady: false,
    disabled: false,
  },
  Senpic: {
    MinTrackAge: '00:00:25',
    IouThreshold: 0.8,
    CostThreshold: 0.6,
    WithPlatesOnly: true,
    MaxDetectionAge: '00:00:55',
    SimilarityThreshold: 0.85,
  },
};
